import { Address, PersonInfoCommon } from '../types/CommonModel';
import AxiosService from './axiosService';

const axiosService = new AxiosService();
axiosService.setWithCredentials(false);

export const mapDawaAddress = async (address: Address | PersonInfoCommon, dawa: any) => {
	address.address = dawa.matchText;
	address.zipCode = dawa.data.postnr;
	address.zipName = dawa.data.postnrnavn;
	address.streetName = dawa.data.vejnavn;
	address.houseNr = dawa.data.husnr;
	address.floorNr = dawa.data.etage;
	address.doorNr = dawa.data.dør;
	address.streetCode = dawa.data.vejkode;
	const res = await axiosService.getQuery(dawa.data.href, {});
	address.kvhxValue = res?.data?.kvhx ?? res?.data?.kvh;
	// DEBUG console.log('Address', address);
};

export const handleDawaAddressSearch = async (
	address: Address | PersonInfoCommon,
	homeAddress: Address | PersonInfoCommon,
	dawa: any
) => {
	if (dawa?.matchText) {
		await mapDawaAddress(address, dawa);
		copyAddress(address, homeAddress);
		return true;
	}

	resetAddress(address);
	resetAddress(homeAddress);
	return false;
};

export const copyAddress = (from: Address | PersonInfoCommon, to: Address | PersonInfoCommon) => {
	to.address = from.address;
	to.zipCode = from.zipCode;
	to.zipName = from.zipName;
	to.streetName = from.streetName;
	to.houseNr = from.houseNr;
	to.floorNr = from.floorNr;
	to.doorNr = from.doorNr;
	to.streetCode = from.streetCode;
	to.kvhxValue = from.kvhxValue;
};

export const resetAddress = (address: Address | PersonInfoCommon) => {
	address.address = undefined;
	address.zipCode = undefined;
	address.zipName = undefined;
	address.streetName = undefined;
	address.houseNr = undefined;
	address.floorNr = undefined;
	address.doorNr = undefined;
	address.kvhxValue = undefined;
	address.streetCode = undefined;
};
